var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-cos-item"},[_c('div',{staticClass:"form-cos-item__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{class:_vm.date ? 'form-cos-item__input__date': 'form-cos-item__input'},[_vm._t("input")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }